import { View } from "react-native";
import { Text } from "react-native-paper";
import LottieView from "lottie-react-native";

import { ActionsContainer, Button, Modal } from "../../components";

const Footer = ({ onClose }: { onClose(): void }) => {
  return (
    <View className="mb-8 w-full">
      <ActionsContainer hideBorder>
        <Button mode="secondary" onPress={onClose} className="w-full">
          Close
        </Button>
      </ActionsContainer>
    </View>
  );
};

export default function SentForReviewScreen({
  visible,
  onClose,
  messageText = "Your request has been sent to your section for review. Your information will not be updated until approved. Submissions are typically reviewed within 3-7 business days.",
}: {
  visible: boolean;
  onClose(): void;
  messageText?: string;
}) {
  return (
    <Modal {...{ visible, onDismiss: onClose, title: "", fullScreen: true, FooterComponent: <Footer onClose={onClose} /> }}>
      <View testID="sentForReviewModal" className="items-center mt-10">
        <View className="w-40 h-40">
          <LottieView
            style={{ flex: 1 }}
            autoPlay
            loop={false}
            source={require("../../../assets/lottie-icons/checklist.json")}
          />
        </View>
        <Text className="text-title-2 font-700 mt-10">Sent for Review</Text>

        <Text className="text-regular-normal font-400 mt-6 mx-8 text-center">{messageText}</Text>
      </View>
    </Modal>
  );
}
